export default class Microsite {
  constructor() {
    if ($(".microsite").length) {
      this.contactForm();
      this.giveForm();

      // make sure the complex nav isn't being used
      if (!$("#complex-menu-bar").length) {
        this.sidebar();
      }
    }
  }

  toggleBurger() {
    $(".burger").toggleClass("burger-open");
    $(".microsite-sidebar").toggleClass("open");
    $("body").toggleClass("burger-open");
  }

  sidebar() {
    const burgerButton = $(".burger-bun-legacy");
    const burger = $(".burger-legacy");

    if (burgerButton.length > 0) {
      $(window).on("resize", () => {
        if (burger.hasClass("burger-open")) {
          this.toggleBurger();
        }
      });

      burgerButton.on("click", (e) => {
        e.stopPropagation();

        this.toggleBurger();
      });

      $("body").on("click", () => {
        if (burger.hasClass("burger-open")) {
          this.toggleBurger();
        }
      });
    }
  }

  contactForm() {
    // contact_form
    $("#micrositeContactFormHeader")
      .on("ajax:success", function (e, data, status, xhr) {
        $("#micrositeContactFormHeader .responseText").html(
          "<p class='text-success'> " + xhr.responseJSON.notice + "</p>",
        );
        $('input[name*="first_name"]').val("");
        $('input[name*="last_name"]').val("");
        $('input[name*="email"]').val("");
      })
      .on("ajax:error", function (e, xhr, status, error) {
        $("#micrositeContactFormHeader .responseText").html(
          "<p class='text-danger'> " + xhr.responseJSON.errors + "</p>",
        );
      });

    $("#micrositeContactFormCta")
      .on("ajax:success", function (e, data, status, xhr) {
        $("#micrositeContactFormCta .responseText").html(
          "<p> " + xhr.responseJSON.notice + "</p>",
        );
        $('input[name*="first_name"]').val("");
        $('input[name*="last_name"]').val("");
        $('input[name*="email"]').val("");
      })
      .on("ajax:error", function (e, xhr, status, error) {
        $("#micrositeContactFormCta .responseText").html(
          "<p> " + xhr.responseJSON.errors + "</p>",
        );
      });
  }

  giveForm() {
    $(".m-site-give-form").on("submit", function (e) {
      e.preventDefault();
      let money = $(".m-site-give-form .money").val();
      let location = $(".m-site-give-form .campaign-link").val();
      window.open(location + "/#/donation?amount=" + money, "_blank");
    });
  }

}
